import FilterByTagsDropdown from "./filter_by_tags_dropdown";

export {
  FilterByTagsDropdown
};



// WEBPACK FOOTER //
// ./src/views/project_control_register/index.js